var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0026 6.57109L15.4226 10.9911L11.0026 15.4111L6.58256 10.9911L11.0026 6.57109ZM11.0026 18.1911L3.80256 10.9911L11.0026 3.79109L17.0026 9.79109V6.16109L12.4226 1.58109C11.6426 0.801094 10.3726 0.801094 9.59256 1.58109L1.58256 9.58109C0.802559 10.3611 0.802559 11.6311 1.58256 12.4111L9.59256 20.4111C10.3726 21.1911 11.6426 21.1911 12.4226 20.4111L17.0026 15.8211V12.1911L11.0026 18.1911ZM19.0026 19.0011H21.0026V21.0011H19.0026V19.0011ZM21.0026 9.00109H19.0026V17.0011H21.0026V9.00109Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicksIcon);
export default __webpack_public_path__ + "static/media/picks-icon.33780cda8e843a6d01830c45bedad11f.svg";
export { ForwardRef as ReactComponent };